import {MetaEventName, MetaEventParams} from "@/helpers/meta/metaEvents";
import {loadMetaPixel} from "@/helpers/meta/metaConsent";

const pixelLoadedMap: Record<string, boolean> = {};
let consentReady = false;
let marketingAllowed = false;

type QItem = { name: MetaEventName; params?: Record<string, unknown>; pixelId: string };
const queue: QItem[] = [];


export function getPixelIdForPath(pathname: string): string | null {
    if (pathname === '/bewerben' || pathname.startsWith('/bewerben/')) {
        return process.env.VUE_APP_META_RECRUITING_PIXEL_ID || null;
    }
    if (pathname === '/anmelden' || pathname.startsWith('/anmelden/')) {
        return process.env.VUE_APP_META_PIXEL_ID|| null;
    }
    return null;
}

export function bindConsent(
    getAllowed: () => boolean,
    onChange: (cb: (allowed: boolean) => void) => void,
): void {
    const path = typeof window !== 'undefined' ? window.location.pathname : '/';
    const pixelId = getPixelIdForPath(path);
    if (!pixelId) return; // kein Pixel für diese Seite

    try {
        marketingAllowed = !!getAllowed();
        consentReady = true;
        if (marketingAllowed && !pixelLoadedMap[pixelId]) {
            loadMetaPixel(pixelId);
            pixelLoadedMap[pixelId] = true;
            flushQueue(pixelId);
        }
    } catch {
        // no crash
    }

    onChange((allowed) => {
        marketingAllowed = !!allowed;
        consentReady = true;
        if (marketingAllowed && !pixelLoadedMap[pixelId]) {
            loadMetaPixel(pixelId);
            pixelLoadedMap[pixelId] = true;
            flushQueue(pixelId);
        }
    });
}

export function track<K extends MetaEventName>(eventName: K, params?: MetaEventParams<K>): void {
    const path = typeof window !== 'undefined' ? window.location.pathname : '/';
    const pixelId = getPixelIdForPath(path);
    if (!pixelId) return;

    if (!consentReady) {
        queue.push({ name: eventName, params: params as Record<string, unknown>, pixelId });
        return;
    }
    if (!marketingAllowed || !pixelLoadedMap[pixelId]) {
        return;
    }

    try {
        window.fbq && window.fbq('track', eventName, params as Record<string, unknown>);
    } catch {
        // do nothing
    }
}

function flushQueue(pixelId: string): void {
    if (!marketingAllowed || !window.fbq) return;
    queue
        .filter((q) => q.pixelId === pixelId)
        .forEach((ev) => {
            try {
                (window.fbq as any)('track', ev.name, ev.params);
            } catch {
                // do nothing
            }
        });
}
